import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DmsComponent } from './dms.component';

const dmsRoutes: Routes = [
    {
        path: '',
        component: DmsComponent,
        children: [],
    },
];

@NgModule({
    imports: [RouterModule.forChild(dmsRoutes)],
    exports: [RouterModule],
})
export class DmsRoutingModule {}
